import { render } from "./Employement.vue?vue&type=template&id=581b2d50"
import script from "./Employement.vue?vue&type=script&lang=js"
export * from "./Employement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__